import { Component, Input } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { GlobalSettingsFormShape } from '../../components/smart-cart-form-global-settings/global-settings.model';
import { GoalsProgressBarFormShape } from './goals-progress-bar.model';
import { readDisplayConditionsGroup } from '../../components/smart-cart-form-display-conditions/display-conditions.model';

type VisualTab = 'settings' | 'goals' | 'timer' | 'display-conditions';

@Component({
  selector: 'smart-cart-form-goals-progress-bar-editor',
  templateUrl: './goals-progress-bar.component.html',
  styleUrls: ['./goals-progress-bar.component.scss'],
  standalone: false,
})
export class SmartCartFormGoalsProgressBarEditorComponent {
  @Input({ required: true }) formGroup!: FormGroup<GoalsProgressBarFormShape>;
  @Input({ required: true }) globalSettingsFormGroup!: FormGroup<GlobalSettingsFormShape>;
  @Input() usageToken = '';
  @Input() smartCartId: number | null = null;

  activeTab: VisualTab = 'settings';

  onTabChange(tab: VisualTab): void {
    this.activeTab = tab;
  }

  get displayConditionsGroup(): UntypedFormGroup | null {
    return readDisplayConditionsGroup(this.formGroup);
  }
}
